import React, { useEffect } from "react";
import { SiteHeader } from "./components/SiteHeader";
import { HeroSection } from "./components/HeroSection";
import { ProblemsSection } from "./components/ProblemsSection";
import { TransformationSection } from "./components/TransformationSection";
import { VolumesSection } from "./components/VolumesSection";
import { BonusesSection } from "./components/BonusesSection";
import { PlanSection } from "./components/PlanSection";
import { OfferSection } from "./components/OfferSection";
import { ProductDemoSection } from "./components/ProductDemoSection";
import { FaqSection } from "./components/FaqSection";
import { DigitalAccessSection } from "./components/DigitalAccessSection";
import { FinalCtaSection } from "./components/FinalCtaSection";
import { GuaranteeSection } from "./components/GuaranteeSection";
import { ContactSection } from "./components/ContactSection";
import { SiteFooter } from "./components/SiteFooter";
import { MobileStickyCta } from "./components/MobileStickyCta";
import { LocalizedPricesProvider } from "./contexts/LocalizedPricesContext";
export function App() {
  useEffect(() => {
    document.title = "De tu cocina a tus primeros pedidos | Aura Content";
  }, []);
  return <LocalizedPricesProvider data-id="element-0" data-mp="3rcsy3udgkeef">
    <div className="min-h-screen w-full bg-cream-50 font-sans" data-id="element-1" data-mp="3reltgdimfc74">
      <SiteHeader data-id="element-2" data-mp="4n725ibkvc5" />
      <main data-id="element-3" data-mp="56qjqnmbrsa">
        <HeroSection data-id="element-4" data-mp="7svdij4jt6t" />
        <ProblemsSection data-id="element-5" data-mp="2zld1r8m3ndb0" />
        <TransformationSection data-id="element-6" data-mp="2zm4wyibsb90r" />
        <VolumesSection data-id="element-7" data-mp="2zmwl5831y4h0" />
        <BonusesSection data-id="element-8" data-mp="33mowttnqsqql" />
        <PlanSection data-id="element-9" data-mp="33lwywc6oagx5" />
        <OfferSection data-id="element-10" data-mp="33ngfy505kvzz" />
        <ProductDemoSection data-id="element-11" data-mp="33oriy2lrxzq1" />
        <FaqSection data-id="element-12" data-mp="38m1gk5jbhhoy" />
        <DigitalAccessSection data-id="element-13" data-mp="38li77d7qg1mj" />
        <GuaranteeSection data-id="element-14" data-mp="38k6x6vnp1xmz" />
        <FinalCtaSection data-id="element-15" data-mp="38o4d78ez692n" />
        <ContactSection data-id="element-16" data-mp="3dle46si0issl" />
      </main>
      <SiteFooter data-id="element-17" data-mp="3dmfo7mh0apmg" />
      <MobileStickyCta data-id="element-18" data-mp="3dirvuqnas99b" />
    </div>
    </LocalizedPricesProvider>;
}